import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import ViewProfileLayer from "./Component/ViewProfileLayer";

const ViewProfilePage = () => {
  return (
    <>
      {/* Header */}
      <div className="d-flex align-items-center gap-2 mb-3">
        <div className="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-amber-100 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
          <Icon icon="solar:user-circle-bold" className="tw-text-lg tw-text-amber-600" />
        </div>
        <div>
          <h6 className="fw-semibold mb-0 tw-text-sm tw-text-gray-800">Profile Management</h6>
          <p className="mb-0 tw-text-xs tw-text-gray-500">View and manage your profile</p>
        </div>
      </div>

      {/* ViewProfileLayer */}
      <ViewProfileLayer />
    </>
  );
};

export default ViewProfilePage;
